<template>
 <div>
    <a-dropdown :trigger="['click']" v-model="show">
      <div slot="overlay" style="background: #ffffff;position: relative">
<!--        <p style="position:absolute;right: 85px;top: 15px;color: #0a5ba8;cursor: pointer;z-index: 999" @click="handleSendMessage"  v-permission="['b_addMsgSysmsg']">发消息</p>-->
<!--        <p style="position:absolute;right: 10px;top: 15px;color: #0a5ba8;cursor: pointer;z-index: 999" @click="handleSendMessageview"  v-permission="['b_addMsgSysmsg']">发送情况</p>-->
        <a-spin :spinning="loading">
          <a-tabs class="dropdown-tabs" :tabBarStyle="{textAlign: 'center'}" :style="{width: '500px',background:'white',border:'1px solid #cccccc'}">
            <a-tab-pane tab="未读" key="1">
              <a-list :data-source="TipsInfoList" style="margin: 0 10px;">
                <template #loadMore>
                  <div :style="{ textAlign: 'center', marginTop: '12px', height: '32px', lineHeight: '32px' }">
                    <a-spin :spinning="loading"><a-button v-if="loadingMore && curPage>1"  @click="loadFirst">到第一页</a-button></a-spin>
                    <a-button v-if="!loadingMore" @click="loadMore">更多</a-button>
                  </div>
                </template>
                <a-list-item slot="renderItem" slot-scope="item, index" >
                  <a :class ="{'msgactive':item.receiveLevel == 1,'renderItem-a':true}" @click="handleMessageInfo(item)">
                    <span class="Message-text">{{item.title}}</span>
                    <span style="color:red;padding-top: 5px">{{item.sendTime}}</span>
                  </a>
                </a-list-item>
              </a-list>
              <!--            <a-list class="tab-pane">-->
              <!--              <a-list-item v-for="(item,index) in TipsInfoList" :key="index">-->
              <!--                <a-list-item-meta :title="item.title" :description="item.sendTime">-->
              <!--                  <a-avatar style="background-color: white" slot="avatar" src="https://gw.alipayobjects.com/zos/rmsportal/ThXAXghbEsBCCSDihZxY.png"/>-->
              <!--                </a-list-item-meta>-->
              <!--              </a-list-item>-->
              <!--            </a-list>-->

            </a-tab-pane>
            <a-tab-pane tab="全部" key="2">

              <a-list :data-source="AllTipsInfoList" style="margin: 0 10px;"   >
                <template #loadMore>
                  <div :style="{ textAlign: 'center', marginTop: '12px', height: '32px', lineHeight: '32px' }">
                    <a-spin :spinning="loading" ><a-button  v-if="loadingAMore && curAPage>1" @click="loadAFirst">到第一页</a-button></a-spin>
                    <a-button v-if="!loadingAMore" @click="loadAMore">更多</a-button>
                  </div>
                </template>

                <a-list-item slot="renderItem" slot-scope="item, index" >
                  <a :class ="{'msgactive':item.receiveLevel == 1,'renderItem-a':true}" @click="handleMessageInfo(item)">
                    <span class="Message-text">{{item.title}}</span>
                    <span style=" padding-top: 5px">{{item.sendTime}}</span>
                  </a>
                </a-list-item>
              </a-list>
            </a-tab-pane>



            <!--          <a-tab-pane tab="待办" key="3">-->
            <!--            <a-list class="tab-pane"></a-list>-->
            <!--          </a-tab-pane>-->
          </a-tabs>
        </a-spin>
      </div>
      <span @click="fetchNotice" class="header-notice">
<!--      <a-badge class="notice-badge" :count="TipsInfoList.length"  :overflow-count="9">-->
        <svg-message-one theme="outline" size="24" fill="#0A5BA8"/>
        <!--        <a-icon :class="['header-notice-icon']" type="bell" />-->
<!--      </a-badge>-->
    </span>
    </a-dropdown>

    <use-modal
      :modal-visible="modalVisible"
      :is-read-only="isReadOnly"
      :dis-block="disBlock"
      :ok-text="okText"
      :modal-title="modalTitle"
      :modal-width="modalW"
      :modal-height="modalH"
      @handleCancel="modalCancel"
      @handleOk="handleSubmit"
    >
      <component
        ref="ModleForm"
        :is="comName"
        :formVal="form"
        :is-read-only="isReadOnly"
        @getSelectRows="getSelectRows"
      ></component>
    </use-modal>

   <use-modal
     :modal-visible="modalViewVisible"
     :is-read-only="isReadOnly"
     :dis-block="disBlock"
     :modal-title="modalTitle"
     :modal-width="modalW"
     :modal-height="modalH"
     @handleCancel="modalCancel"
   >
     <component
       ref="ModleForm"
       :is="comName"
       :formVal="form"
       :is-read-only="isReadOnly"
       @getSelectRows="getSelectRows"
     ></component>
   </use-modal>

 </div>
</template>

<script>
import moment from "moment";
import MessageInfo from "../MessageInfo"
import UseModal from "@/components/UseModal.vue";

import SendMessage from"./SendMessage"
import SendMessageView from"./SendMessageView"

export default {
  name: 'HeaderNotice',
  data () {
    return {
      modalVisible: false,
      isReadOnly: false,
      disBlock: true,
      isAdd: false,
      okText: "发送消息",
      modalTitle: "",
      modalW: 900,
      modalH: "auto",
      comName:"MessageInfo",
      form:{},
      selectuserId:[],
      loading: false,
      show: false,
      loadingMore: false,
      allPages:1,
      curPage:1,
      loadingAMore: false,
      allAPages:1,
      curAPage: 1,
      pageSize:6,
      TipsInfoList:[],
      AllTipsInfoList:[],
      modalViewVisible: false
    }
  },

  computed: {
  },
  components: {
    MessageInfo,
    UseModal,
    SendMessage,
    SendMessageView
  },
  mounted() {
    this.getMessagelist();

  },
  watch: {
    modalVisible(val, oldVal) {
      if(val){

          // this.$refs.useTable.selectedRowKeys = [];
          // this.$refs.useTable.tableSelectArr = [];

      }
    }
  },
  methods: {
    getSelectRows(selectRows){
      console.log(selectRows);
      let selectuserId = selectRows.map(item => item.id);
      console.log(selectuserId)
      this.selectuserId = selectuserId;

    },
    getMessagelist(){
      const uri = "queryMsgSysmsg";
      this.$json(uri, {}).then(response => {
        console.log(response);
        // let data = response.record;
        // this.total = response.total;
        // this.data = data;
      }).catch(e => {
        this.$message.error(e.message);
      });
    },
    handleSendMessage(){
      this.modalTitle = "消息";
      this.isReadOnly = true;
      this.disBlock = true;
      this.show = false;
      this.setComName("SendMessage", this.modalW);
      this.modalVisible = true;
      this.modalH = "600"
    },

    handleSendMessageview(){
      this.modalTitle = "发送短信情况";
      this.isReadOnly = true;
      this.disBlock = true;
      this.show = false;
      this.setComName("SendMessageView", this.modalW);
      this.modalViewVisible = true;
      this.modalH = "600"
    },
    handleSubmit(e){
      console.log(e);
      const ref = Object.keys(e.$refs)[0];
      let form = e.form;
      e.$refs[ref].validate(valid => {
        console.log(valid)
        if (valid) {
          let form2 = {
            title:form.title,
            sendType:form.sendType,
            content:form.content,
            smsFlag:form.smsFlag
          };
          if(form.sendType == 1){
            let searchForm = e.$refs.searchForm.form;
            form2 = {
              ...form2,
              ...searchForm
            };
            if(!searchForm.province && !searchForm.city && !searchForm.country){
              this.$message.error("请选择查询条件");
              return false;
            }
          }else if(form.sendType == 2){
            form2.userId = this.selectuserId;
            form2.selUsers= form.selUsers;
            if( form2.selUsers.length == 0){
              this.$message.error("请选择人员");
              return false;
            }
          }else if(form.sendType == 3){
            form2.mobiles =form.mobiles;
          }else if(form.sendType == 4){
            form2.roleId =form.roleId;
          }
          this.$json("addMsgSysmsg", form2).then(response => {
            console.log(response)
              this.modalVisible = false;
            this.modalViewVisible = false;
            }).catch(e => {
              this.$message.error(e.message);
            });
        }

      })
    },
    modalCancel(bool) {
      this.form = {};
      this.modalVisible = bool;
      this.modalViewVisible = false;
      this.isReadOnly = false;
      this.disBlock = true;
    },
    setComName(comName, modalW) {
      this.modalW = modalW;
      this.comName = comName;
    },
    handleMessageInfo(info){
      this.modalTitle = "提示信息";
      this.isReadOnly = true;
      this.disBlock = false;
      this.loading = false;
      this.show = false;
      this.form = info;
      this.setComName("MessageInfo", this.modalW);
      this.modalVisible = true;
      this.modalH = "400";
      //文章阅读处理
      const params = {
        url:"viewMsgSysmsg",
        query:{msgId: info.msgId}
      };
      this.$json(params.url, params.query).then(response => {
        console.log("查看消息！")
      });

    },
    getMessageInfo(){
      const params = {
        url:"queryMsgSysmsg",
        query:{readFlag: 0,
          pageSize: this.pageSize,
          pageNo: this.curPage}
      };
      this.$json(params.url, params.query).then(response => {
        const {total,record} = response;
        if(total == 0){
          this.TipsInfoList = [];
          this.loadingMore = true;
          return false;
        }else{
          this.allPages   = Math.ceil(total/this.pageSize);
          if(this.curPage >=this.allPages){
            this.loadingMore = true;
          }else{
            this.loadingMore = false;
          }
          // this.curAPage =1;
        }
        const Msglist = record.map((item,index) =>{
          item.sendTime = moment(item.sendTime).format("YYYY-MM-DD");
          return item;
        })
        this.TipsInfoList = Msglist
      });

    },
    getAllMessageInfo(){
      const params = {
        url:"queryMsgSysmsg",
        query:{pageSize: this.pageSize,
          pageNo: this.curAPage}
      };
      this.$json(params.url, params.query).then(response => {
        const {total,record} = response;
        if(total == 0){
          this.AllTipsInfoList = [];
          this.loadingAMore = true;
          return false;
        }else{
          this.allAPages   = Math.ceil(total/this.pageSize);
          // this.curAPage =1;
          if(this.curAPage >=this.allAPages){
            this.loadingAMore = true;
          }else{
            this.loadingAMore = false;
          }
        }
        const Msglist = record.map((item,index) =>{
          item.sendTime = moment(item.sendTime).format("YYYY-MM-DD");
          return item;
        })
        this.AllTipsInfoList = Msglist
      });

    },
    loadMore(){
      console.log("loadmore");
      this.curPage = this.curPage +1;
      if(this.curPage >=this.allPages){
        this.loadingMore = true;
      }else{
        this.loadingMore = false;
      }
      this.getMessageInfo();
    },
    loadAMore(){

      this.curAPage = this.curAPage +1;
      if(this.curAPage >=this.allAPages){
        this.loadingAMore = true;
      }else{
        this.loadingAMore = false;
      }
      this.getAllMessageInfo();
      // console.log("loadmore");
    },

    loadFirst(){
      this.curPage = 1;
      if(this.curPage >this.allPages){
        this.loadingMore = true;
      }else{
        this.loadingMore = false;
      }
      this.getMessageInfo();
    },

    loadAFirst(){
      this.curAPage = 1;
      if(this.curAPage >this.allAPages){
        this.loadingAMore = true;
      }else{
        this.loadingAMore = false;
      }
      this.getAllMessageInfo();
    },
    beforeMount() {
      console.log("beforeMount");
      this.getMessageInfo();
    },
    fetchNotice () {
      this.getMessageInfo();
      this.getAllMessageInfo();
      if (this.loading) {
        this.loading = false
        return
      }
      if (this.show) return
      this.loading = true
      setTimeout(() => {
        this.loading = false
      }, 1000)
    }
  }
}
</script>

<style lang="less">
.msgactive{
  color: red;
}
.renderItem-a{
  width: 96%;
  padding: 0 2%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  //align-items: center;
  //margin: 0.5em 0;
  .Message-text{
    width: 350px;
    overflow: hidden; //超出的文本隐藏
    text-overflow: ellipsis; //溢出用省略号显示
    display: -webkit-box;
    -webkit-line-clamp: 2; // 超出多少行
    -webkit-box-orient: vertical;
  }
  p{
    width: 170px;
  }
}
.header-notice{
  display: flex;
  align-items: center;
  display: inline-block;
  cursor: pointer;
  transition: all 0.3s;
  //margin-right: 20px;
  margin-left: 20px;
  span {
    vertical-align: middle;
  }
  .notice-badge{
    color: inherit;
    .header-notice-icon{
      font-size: 16px;
      padding: 4px;
    }
  }
}
.dropdown-tabs{
  //background-color: @base-bg-color;
  //box-shadow: 0 2px 8px @shadow-color;
  border-radius: 4px;
  .tab-pane{
    padding: 0 24px 12px;
    min-height: 250px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/layout/header/HeaderNotice.vue